import { Dropdown, Table, Form, Button, Modal } from "react-bootstrap";
import {
  FilterIcon,
  SummaryChartIconUp,
  SummaryCloseIcon,
  FilterCollapseIcon,
  DeleteIcon,
  EditIcon,
} from "../Icons";
import "../../assets/scss/reports/cashbook.scss";
import "../../assets/scss/dashboard.scss";
import { useEffect, useRef, useState } from "react";
import CachedIcon from "mdi-react/CachedIcon";
import Select from "react-select";
import useDebounce, {
  useCurrencies,
  useLocalStorage,
  useQueryParams,
  useScrollTop,
} from "../../utils/hooks";
import { useQuery, useMutation } from "react-query";
import currency from "currency.js";
import { endOfDay, format, parse, startOfDay } from "date-fns";
import ReactPaginate from "react-paginate";
import { fetchActionsUtil, paginationOptions } from "../../utils/helpers";
import queryString from "query-string";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import NoTableItem from "../utils/NoTableItem";
import ModalLoader from "../utils/ModalLoader";
import { IsPrivileged } from "../DisplayChildElement";
import * as yup from "yup";
import { read, utils } from "xlsx";
import InvoiceLayout from "./InvoiceWrapper";
import ChevronDownIcon from "mdi-react/ChevronDownIcon";
import DotsHorizontalIcon from "mdi-react/DotsHorizontalIcon";
import EyeOffOutlineIcon from "mdi-react/EyeOffOutlineIcon";
import EyeOutlineIcon from "mdi-react/EyeOutlineIcon";
import CustomInvoiceTableComponent from "../CustomInvoiceTableComponent";
import InvoiceAnalysisChart from "./InvoiceAnalysisChart";
import InvoiceAnalysisPieChart from "./InvoiceAnalysisPieChart";
import InvoiceInnerPageLayout from "../InvioiceInnerPageLayout";
import Avatar from "../utils/Avatar";
import CustomerAvatar from "../utils/CustomerAvatar";
import DamagesTable from "../warehouse/DamagesTable";
import CashIcon from "mdi-react/CashIcon";
import CurrencyCustomInput from "../utils/CurrencyCustomInput";
import { FilesAttachments } from "../../utils/Attachments";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import Creatable from "react-select/creatable";

/* const currenciesOptions = [
    {
      label: "All Currencies",
      value: "",
    },
    ...currencies.map((el) => ({
      ...el,
      label: `${el.name} (${el.symbol})`,
      value: el.cc,
    })),
  ]; */
const boats = [
  {
    value: "71ft and above",
    label: "71ft and above",
  },
  {
    value: "61ft to 70ft",
    label: "61ft to 70ft",
  },
  {
    value: "50ft to 60ft",
    label: "50ft to 60ft",
  },
  {
    value: "46ft to 49ft",
    label: "46ft to 49ft",
  },
  {
    value: "34ft to 39ft",
    label: "34ft to 39ft",
  },
  {
    value: "Up to 33ft",
    label: "Up to 33ft",
  },
];

const BoatRegistrationModal = ({
  show,
  setShow,
  refetch,
  item,
  setEditItem,
}) => {
  const { backendUrl } = useAuth();
  const { prevailingCurrencySymbol } = useCurrencies();
  const [boatSize, setBoatSize] = useState(boats);

  const validationSchema = Yup.object({
    size: Yup.string().required("Size is required"),
    type: Yup.string().required("Description is required"),
    price: Yup.number()
      .moreThan(0, "Price must be greater than 0")
      .required("Price is required"),
  });
  const formik = useFormik({
    validationSchema,
    initialValues: {
      size: "",
      type: "",
      price: 0,
      id: "",
    },

    onSubmit: values => {
      submitMutation.mutate(values);
    },
  });

  useEffect(() => {
    if (!isEmpty(item)) {
      formik.setFieldValue("size", item?.size || "");
      formik.setFieldValue("price", item?.price || 0);
      formik.setFieldValue("type", item?.type || "");
      formik.setFieldValue("id", item?.id || "");
    }
  }, [item]);

  const submitMutation = useMutation(
    async payload =>
      fetchActionsUtil(`${backendUrl}/api/items/boat`, "POST", "", payload),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        formik.resetForm();
        refetch();
        setShow(false);
        setEditItem(null);
      },
      onError: ({ message }) => {
        toast.error(`Unable to perform ${message}`);
      },
    }
  );

  return (
    <Modal onHide={() => setShow(false)} show={show}>
      <Modal.Header closeButton>
        <Modal.Title as={"h6"}>
          {" "}
          {item?.id ? "Edit" : "Register"} a boat
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={formik.handleSubmit}>
          <div className="row">
            <Form.Group className="mb-3">
              <Form.Label>Size</Form.Label>

              <Creatable
                isSearchable
                isClearable
                classNamePrefix="form-select"
                placeholder="Select or input your city"
                options={boatSize}
                value={
                  boatSize.find(el => el.value === formik.values.size) || {
                    value: formik.values.size,
                    label: formik.values.size,
                  }
                }
                onCreateOption={inputValue => {
                  const newOption = { value: inputValue, label: inputValue };
                  setBoatSize(prev => [...prev, newOption]);
                  formik.setFieldValue("size", inputValue);
                }}
                onChange={selected =>
                  formik.setFieldValue("size", selected?.value)
                }
                inputProps={{ autoComplete: "off" }}
              />
              {formik.touched.size && formik.errors.size && (
                <Form.Control.Feedback type="invalid">
                  {formik.errors.size}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            {/* Price */}
            <Form.Group className="mb-3">
              <Form.Label>Type</Form.Label>

              <Select
                classNamePrefix="form-select"
                menuPosition="fixed"
                className=""
                menuPlacement="auto"
                placeholder="select type"
                name="type"
                key={"type"}
                value={
                  [
                    { value: "Corporate", label: "Corporate" },
                    { value: "Individual", label: "Individual" },
                  ].find(el => el?.value === formik.values?.type) || {
                    value: formik.values.type,
                    label: formik.values.type,
                  }
                }
                onChange={selected => {
                  formik.setFieldValue("type", selected?.value);
                }}
                options={
                  [
                    { value: "Corporate", label: "Corporate" },
                    { value: "Individual", label: "Individual" },
                  ] || []
                }
                isClearable
              />
              {formik.touched.type && formik.errors.type && (
                <div className="text-danger">{formik.errors.type}</div>
              )}
            </Form.Group>

            {/* Category */}
            <Form.Group className="mb-3">
              <Form.Label>Price</Form.Label>
              <CurrencyCustomInput
                name="price"
                value={formik.values.price}
                onValueChange={(value, name) => {
                  formik.setFieldValue(name, value);
                }}
                currencySymbol={prevailingCurrencySymbol}
                onBlur={formik.handleBlur}
                placeholder="0.00"
              />
              {formik.touched.price && formik.errors.price && (
                <div className="text-danger">{formik.errors.price}</div>
              )}
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={submitMutation.isLoading}
          type="submit"
          onClick={() => formik.handleSubmit()}
        >
          {submitMutation.isLoading ? "Saving..." : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default function CustomerBoatList({ icon, name, invoiceType }) {
  useScrollTop();
  const navigate = useNavigate();
  const { backendUrl, token, user: authUser } = useAuth();

  const initialFilterParams = {
    q: "",
  };

  const {
    deploymentCurrencies: currenciesOptions,
    prevailingCurrency,
    getCurrencySymbol,
    prevailingCurrencySymbol,
  } = useCurrencies();
  const [showFilter, setShowFilter] = useLocalStorage("sshowFilter", false);
  const [btnSummryActive, setBtnSummaryActive] = useState(false);
  const [, setShowMoreSummary] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState({});

  const close = () => {
    setShowMoreSummary(true);
    setBtnSummaryActive(false);
  };

  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });

  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });

  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({
      ...queryParams,
      ...debouncedFilterParams,
    });
  }, [debouncedFilterParams]);

  const fetchCustomStoreMenu = async queryParams => {
    // await waitFor(5000);
    let response = await fetch(
      `${backendUrl}/api/items/boat?${queryString.stringify(queryParams)}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const data = await response.json();

    return data;
  };

  const { data, refetch, isFetching, isSuccess, isLoading } = useQuery(
    ["GET_BOAT_LIST", queryParams],
    () => fetchCustomStoreMenu(queryParams),
    {
      keepPreviousData: true,
    }
  );

  const handleFilterParamsChange = e => {
    setFilterParams({
      ...filterParams,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const handleSearchQueryChange = e => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  const filterByDateRange = date => {
    setFilterParams({
      ...filterParams,
      startDate: format(date[0], "yyyy-MM-dd"),
      endDate: format(date[1], "yyyy-MM-dd"),
      enableDateRange: true,
    });
  };

  const clearDateRange = () => {
    setFilterParams({
      ...filterParams,
      startDate: "",
      endDate: "",
    });
  };

  const search = () => {
    setQueryParams({
      ...queryParams,
      ...filterParams,
    });
  };

  const reset = () => {
    setFilterParams(initialFilterParams);
    setQueryParams({
      ...queryParams,
      ...initialFilterParams,
    });
  };

  const handleUpdate = item => {
    setEditItem(item);
    setShowModal(true);
  };

  const tableData = (el, index) => {
    return (
      <>
        <td>{filterParams.limit * (filterParams.page - 1) + index + 1}</td>
        <td>{el?.size}</td>
        <td>{el?.type}</td>
        <td>
          {currency(el?.price).format({
            separator: ",",
            symbol: prevailingCurrencySymbol,
          })}
        </td>

        <td>
          <Dropdown>
            <Dropdown.Toggle
              variant=""
              className="bg-white border rounded-3"
              bsPrefix="print more"
            >
              <DotsVerticalIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu
              popperConfig={{
                strategy: "fixed",
              }}
              renderOnMount
              className="dropdown-with-icons"
            >
              <Dropdown.Item as="button" onClick={() => handleUpdate(el)}>
                <EditIcon /> Update
              </Dropdown.Item>
              <Dropdown.Item
                className="  btn-danger"
                as="button"
                onClick={() => deleteMenuItemMutation.mutate(el?.id)}
              >
                <DeleteIcon />
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>{" "}
          </Dropdown>
        </td>
      </>
    );
  };

  const deleteMenuItemMutation = useMutation(
    payload =>
      fetchActionsUtil(`${backendUrl}/api/items/boat/${payload}`, "DELETE"),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        refetch();
      },
      onError: () => {
        toast.error(`Unable to perform action`);
      },
    }
  );

  return (
    <IsPrivileged
      roleName={[
        "Sale by Invoice",
        "Invoice List",
        "Invoices",
        "Enable Custom Store Menu",
        "Boat List",
      ]}
    >
      <InvoiceInnerPageLayout
        name={name}
        icon={icon}
        description={"Your current sales summary and activity"}
      />
      <main className="cash-book ">
        <div className="content border rounded-4">
          <div className="content-main">
            <div
              className={` mt-2 filter-area ${showFilter ? "open" : "close"}`}
            >
              <div className="filter-header">
                <h2>
                  <FilterIcon color="#94A3B8" /> Filter
                </h2>

                <Button
                  variant="white"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <FilterCollapseIcon />
                </Button>
              </div>
              <div className="filter-body ">
                <Form>
                  <div className="body">
                    {" "}
                    {/* <Form.Group className="mb-2-5">
                      <Form.Label>Transaction ID</Form.Label>{" "}
                      <InputGroup>
                        <Form.Control
                          name="TransactionID"
                          value={filterParams?.TransactionID}
                          placeholder="Enter Transaction ID"
                          onChange={(e) => handleFilterParamsChange(e)}
                        />{" "}
                        <Popover
                          isOpen={showTransactionPopover}
                          onClickOutside={() =>
                            setShowTransactionPopover(false)
                          }
                          content={() => (
                            <TransactionsTable
                              handleSelectedTransaction={
                                handleSelectedTransaction
                              }
                            />
                          )}
                          position="bottom"
                        >
                          <InputGroup.Text
                            onClick={() =>
                              setShowTransactionPopover(!showTransactionPopover)
                            }
                          >
                            <MagnifyIcon />
                          </InputGroup.Text>
                        </Popover>{" "}
                      </InputGroup>
                    </Form.Group>
                    <Form.Group className="mb-2-5">
                      <Form.Label>Customer ID</Form.Label>
                      <InputGroup>
                        <Form.Control
                          name="customerId"
                          placeholder="Enter Customer ID"
                          value={filterParams?.customerId}
                          onChange={(e) => handleFilterParamsChange(e)}
                        />
                        <Popover
                          isOpen={showItemsPopover}
                          onClickOutside={() => setShowItemsPopover(false)}
                          content={() => (
                            <CustomerSelector
                              handleSelectedCustomer={handleSelectedCustomer}
                              setShowCustomerSelector={setShowItemsPopover}
                            />
                          )}
                          position="bottom"
                        >
                          <InputGroup.Text
                            onClick={() =>
                              setShowItemsPopover(!showItemsPopover)
                            }
                          >
                            <MagnifyIcon />
                          </InputGroup.Text>
                        </Popover>
                      </InputGroup>
                    </Form.Group>
                    <Form.Group className="mb-2-5">
                      <Form.Label>Customer Name</Form.Label>
                      <Form.Control
                        name="customerName"
                        value={filterParams?.customerName}
                        placeholder="Enter Customer Name"
                        onChange={(e) => handleFilterParamsChange(e)}
                      />
                    </Form.Group> */}
                    {/*  <Form.Group className="mb-2-5">
                      <Form.Label>Invoice Cat.</Form.Label>
                      <Select
                        classNamePrefix="form-select"
                        menuPosition="fixed"
                        menuPlacement="auto"
                        placeholder="All"
                        theme={reactSelectTheme}
                        isSearchable={false}
                        key={data?.invoiceCat}
                        defaultValue={defaultSelectValue(
                          queryParams?.invoiceCat,
                          data?.invoiceCat,
                          {
                            value: "",
                            label: "All",
                          }
                        )}
                        options={data?.invoiceCat || []}
                        onChange={(selected) => {
                          setFilterParams({
                            ...filterParams,
                            invoiceCat: selected.value,
                          });
                        }}
                      />
                    </Form.Group> */}
                    {/* <hr className="mt-3 mb-4" />
                    <div className="mb-2-5">
                      <Form.Check
                        inline
                        label="Enable Date Range"
                        name="enableDateRange"
                        type={"checkbox"}
                        id={`enableDateRange`}
                        checked={filterParams?.enableDateRange}
                        onChange={(e) => handleFilterParamsChange(e)}
                      />
                    </div>
                    <Form.Group className="">
                      <Form.Label>Date Range</Form.Label>
                      <div className="position-relative">
                        <RsDateRangePicker
                          placement="topStart"
                          value={
                            filterParams.startDate && filterParams.endDate
                              ? [
                                  parse(
                                    filterParams.startDate,
                                    "yyyy-MM-dd",
                                    new Date()
                                  ),
                                  parse(
                                    filterParams.endDate,
                                    "yyyy-MM-dd",
                                    new Date()
                                  ),
                                ]
                              : []
                          }
                          onClean={() => clearDateRange()}
                          onOk={(date) => filterByDateRange(date)}
                        />
                      </div>
                    </Form.Group> */}
                  </div>

                  <div className="buttons rounded">
                    <Button onClick={() => reset()} variant="white">
                      Reset
                    </Button>
                    <Button onClick={() => search()} variant="primary">
                      Search
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
            <div className="content-body">
              <header>
                <h1>
                  Boat List
                  <button
                    title="Refresh"
                    onClick={() => refetch()}
                    className="btn text-primary"
                  >
                    <CachedIcon />
                  </button>
                </h1>
                <div
                  className="actions"
                  style={{
                    zIndex: "10",
                  }}
                >
                  <div className="global-search-area">
                    <MagnifyIcon />
                    <Form.Control
                      name="q"
                      value={filterParams?.q}
                      placeholder="Search..."
                      onChange={e => handleFilterParamsChange(e)}
                      className=" rounded-4 border"
                    />
                  </div>
                  {/* <PrivilegedAction
                          eachRole={{
                            name: "Select Currency",
                            parent: "Invoice List",
                          }}
                        >
                          <Form.Group>
                            <Select
                              classNamePrefix="form-select"
                              placeholder="Select Currency"
                              isSearchable={false}
                              options={currenciesOptions}
                              value={currenciesOptions.find(
                                (el) => el.value == filterParams.currency
                              )}
                              onChange={({ value }) => {
                                setFilterParams({
                                  ...filterParams,
                                  currency: value,
                                });
                              }}
                            />
                          </Form.Group>
                        </PrivilegedAction> */}

                  <Button
                    onClick={() => {
                      setEditItem({});
                      setShowModal(true);
                    }}
                  >
                    + Create New
                  </Button>
                  {/* <PrivilegedAction
                    eachRole={{
                      name: "Show Summary",
                      parent: "Invoice List",
                    }}
                  >
                    <button
                      onClick={() => setBtnSummaryActive(true)}
                      className="btn summaryBtn  rounded-4"
                    >
                      Show Summary
                    </button>
                  </PrivilegedAction> */}

                  {!showFilter && (
                    <Button
                      variant=""
                      onClick={() => setShowFilter(!showFilter)}
                      className="btn filter ms-2 border rounded-4 d-flex align-items-center px-3 gap-2"
                      style={{
                        height: "40px",
                        lineHeight: "40px",
                      }}
                    >
                      Filter <FilterIcon color="#94A3B8" />
                    </Button>
                  )}
                </div>
              </header>

              <div className="px-md-4">
                <Table
                  responsive
                  borderless
                  hover
                  className="text-nowrap product-table"
                >
                  <thead className="bg-white">
                    <tr className=" border-bottom border-top">
                      {/* <th className="py-3">No</th> */}
                      <th className="py-3">S/N</th>
                      <th className="py-3">Size</th>
                      <th className="py-3">Type</th>
                      <th className="py-3">Price</th>
                      <th>Action</th>
                      {/* <th className="py-3">Pay Due</th> */}
                    </tr>
                  </thead>
                  <tbody className="blue-hover mt-3">
                    {data?.data?.map((el, index) => (
                      <tr className=" ">{tableData(el, index)}</tr>
                    ))}
                  </tbody>
                </Table>
                {!isFetching && isSuccess && isEmpty(data?.data) ? (
                  <NoTableItem queryParams={queryParams} />
                ) : null}
              </div>

              <div className="d-flex justify-content-between px-3 align-items-center pagination">
                <div className="pagination_left">
                  <p className="m-0 p-0">Show</p>
                  <select
                    value={queryParams.limit}
                    name="limit"
                    className="form-select "
                    onChange={e => handleSearchQueryChange(e)}
                  >
                    <option value="10">10 rows</option>
                    <option value="20">20 rows</option>
                    <option value="30">30 rows</option>
                    <option value="40">40 rows</option>
                    <option value="50">50 rows</option>
                    <option value="100">100 rows</option>{" "}
                  </select>
                </div>

                <ReactPaginate
                  {...paginationOptions}
                  pageCount={Math.ceil(data?.count / queryParams.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={0}
                  onPageChange={({ selected }) => {
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    setQueryParams({
                      ...queryParams,
                      page: selected + 1,
                    });
                  }}
                  forcePage={queryParams.page - 1}
                />
              </div>

              <div
                className={
                  btnSummryActive
                    ? `summaryNew border-top open`
                    : `summaryNew border-top`
                }
              >
                <div className="summaryHeader">
                  <h2>Summary</h2>
                  {btnSummryActive && (
                    <button onClick={() => close()} className="btn p-0">
                      <SummaryCloseIcon />
                    </button>
                  )}
                </div>

                <div className="gridCont">
                  {/*  <div className="gridChild gridChildBorderLeftBlue">
                    <div className="gridChildLeft">
                      <p className="gridChld1">
                        {currency(data?.totalInvoiceAmt, {
                          symbol: "",
                        }).format()}
                      </p>
                      <p className="gridChld2">Total Invoice Amt (All)</p>
                    </div>

                    <div className="gridChildRight">
                      <SummaryChartIconUp />
                      <p>5%</p>
                    </div>
                  </div> */}

                  <div className="gridChild gridChildBorderLeftOrange">
                    <div className="gridChildLeft">
                      <p className="gridChld1">
                        {currency(
                          filterParams.currency === prevailingCurrency ||
                            !filterParams.currency
                            ? data?.total
                            : 0,
                          {
                            symbol: getCurrencySymbol(prevailingCurrency),
                          }
                        ).format()}
                      </p>
                      <p className="gridChld2">
                        Total Invoice in {prevailingCurrency} (
                        {getCurrencySymbol(prevailingCurrency)})
                      </p>
                    </div>

                    <div className="gridChildRight">
                      <SummaryChartIconUp />
                      <p>5%</p>
                    </div>
                  </div>

                  {/* <div className="gridChild gridChildBorderLeftBrown">
                    <div className="gridChildLeft">
                      <p className="gridChld1">
                        {currency(
                          filterParams.currency === "USD" ||
                            !filterParams.currency
                            ? data?.totalDollar
                            : 0,
                          {
                            symbol: "$",
                          }
                        ).format()}
                      </p>
                      <p className="gridChld2">Total Invoice in USD ($)</p>
                    </div>

                    <div className="gridChildRight">
                      <SummaryChartIconDown />
                      <p>5%</p>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <ModalLoader show={isLoading} /> */}
      </main>

      <BoatRegistrationModal
        show={showModal}
        setShow={setShowModal}
        refetch={refetch}
        item={editItem}
        setEditItem={setEditItem}
      />
    </IsPrivileged>
  );
}
